import React from 'react';
import './ShCenter.css';
import { Carousel, Form } from 'antd';
import { GetExhibitionBanner } from "../../api/api";
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux"
import actions from "../../store/actions"
import VlecImg from "../../component/VlecImg"



let img2 = require("../../static/images/photo-01.png");

class InnovationCenter extends React.Component {
    state = {
        GetExhibitionBanner: [],
    }

    componentWillMount() {

    }
    componentDidMount() {
        /*展厅接口*/
        GetExhibitionBanner('SH').then((response) => {
            let data = response.DataResult;
            this.setState({
                GetExhibitionBanner: data
            });
        });
    }

    render() {
        const centertitle3 = this.props.local === 'en' ?
            <span>Lenovo Shanghai Future Center is located at Lenovo Innovation Park, Pudong New Area, Shanghai. Covering an area of 2298.8 m<sup>2</sup>, the center was officially opened on July 29th, 2021. As an enterprise business innovation center, Lenovo Shanghai Future Center presents the latest achievements of Lenovo's intelligent transformation in all walks of life.</span>
            : <span> 联想上海未来中心位于上海市浦东新区张江联想创新科技园，于2021年7月29日正式开放，占地面积2298.82 m<sup>2</sup>。作为一个商用企业级科技创新展示阵地，联想上海未来中心围绕智慧城市、智能制造、智慧教育、智慧农业、智慧办公等五大行业相关场景，结合人工智能、大数据、高性能计算、物联网等新技术，呈现了联想赋能各行各业实现智能化转型的最新实践成果。</span>;
        const f1Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,1<sup>st</sup>floor<br />— 3,000 m<sup>2</sup></h4> : <h4>联想未来中心1层<br />——3000 m<sup>2</sup></h4>;
        const f2Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,2<sup>nd</sup>floor<br />— 2,000 m<sup>2</sup></h4> : <h4>联想未来中心2层<br />——2000 m<sup>2</sup></h4>;
        const f3Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,3<sup>rd</sup>floor<br />— 1,000 m<sup>2</sup></h4> : <h4>联想未来中心3层<br />——1000 m<sup>2</sup></h4>;
        return (<div>
            {/*轮播图片*/}
            <div>
                <Carousel autoplay>
                    {this.state.GetExhibitionBanner.map((item) => {
                        return <div key={item.ID}>
                            {/* <a href={item.URL}> */}
                            <VlecImg src={item.ImagePath} alt="" />
                            {/* </a> */}

                        </div>
                    })}
                </Carousel>
            </div>
            <div className="indexDiv Innovation_Con">
                <div className="center">
                    <div className="titleH4">
                        <h4>

                            <FormattedMessage
                                id="intl-center-title"
                            />
                        </h4>
                        <p className="shsmartP">
                            {centertitle3}
                            <br />

                        </p>

                    </div>
                </div>
                {/*下面的图片*/}
                {/* <div className="center centerDiv">
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce01.png" alt="" />
                            </dt>
                            <dd>
                                {f1Title}
                                <p><FormattedMessage id="intl-center-f1Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f1Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce02.png" alt="" />
                            </dt>
                            <dd>
                                {f2Title}
                                <p><FormattedMessage id="intl-center-f2Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f2Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce03.png" alt="" />
                            </dt>
                            <dd>
                                {f3Title}
                                <p><FormattedMessage id="intl-center-f3Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f3Des" /></p>
                    </div>
                </div> */}
                <div className="imgDiv">
                    <ul className="shimgBock">
                        <li>
                            <img src="images/sh/city.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-shcenter-citytitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-shcenter-citydes" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sh/manufacturing.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-shcenter-manufacturingtitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-shcenter-manufacturingdes1" />
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-shcenter-manufacturingdes2" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sh/education.jpg" alt="" />
                            <div className="imgHover">
                                <h4> <FormattedMessage id="intl-shcenter-educationtitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-shcenter-educationdes" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sh/agriculture.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-shcenter-agriculturetitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-shcenter-agriculturedes" />
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <img src="images/sh/office.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-shcenter-officetitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-shcenter-officedes" />
                                    </p>
                                </div>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>)
    }
};
export default connect(state => ({ ...state.Language }), actions.Language)(InnovationCenter)


// WEBPACK FOOTER //
// ./src/containers/ShCenter/ShCenter.js